import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  valueCard: {
    width: "500px",
    height: "fit-content",
    backgroundColor: "#FFFFFF",
    border: "1.5px solid #E3EAE4",
    borderRadius: "16px",
    padding: "16px 16px 14px",
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(21, 37, 32, 0.05)",
    transition: "all 160ms ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(21, 37, 32, 0.10)",
      borderColor: "#C9D6CC",
    },
  },
  topRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "12px",
  },
  iconChip: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
  },
  title: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: 1.3,
    color: "#152520",
    paddingTop: "2px",
  },
  metrics: {
    display: "flex",
    alignItems: "baseline",
    gap: "16px",
  },
  bigValue: {
    fontSize: "22px",
    fontWeight: 800,
    lineHeight: 1,
    fontVariantNumeric: "tabular-nums",
    color: "#152520",
  },
  metricLabel: {
    fontSize: "11px",
    color: "#68786F",
    marginTop: "3px",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
  },
});

export default styles;
